import React, { Component } from 'react';

import { calculateTime } from "../../utilities";

import './Timer.css';

class RemoteTimer extends Component {

    renderTime() {
        return (
            <div className="timer-normal">
                {calculateTime(Math.max(this.props.seconds, 0), false)}
            </div>
        );
    }

    render() {
        return (
            <div className="timer-container-remote">
                {this.renderTime()}
            </div>
        );
    }
}

export default RemoteTimer;
